import { render } from "./TitleCard.vue?vue&type=template&id=52ee9af0&scoped=true&ts=true"
import script from "./TitleCard.vue?vue&type=script&lang=ts"
export * from "./TitleCard.vue?vue&type=script&lang=ts"

import "./TitleCard.vue?vue&type=style&index=0&id=52ee9af0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ee9af0"]])

export default __exports__